import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { OpravyZoznam } from "@/components/import/OpravyZoznam";
import { useOpravyZakazky } from "@/api/hooks/useTopsolidRaw";

/**
 * Čo treba opraviť v TopSolide — nálezy z importu tejto zákazky.
 *
 * Zoznam vzniká pri importe a viaže sa na zákazku. Bez neho by tá istá
 * chyba prišla aj pri ďalšom exporte a obchádzala by sa znova.
 *
 * Prázdny stav sa **píše nahlas**: „nič sme neobchádzali“ je odpoveď,
 * nie dôvod ukázať prázdno.
 */
export function OpravyDialog({
  zakazkaId,
  open,
  onOpenChange,
}: {
  zakazkaId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}): JSX.Element {
  const query = useOpravyZakazky(open ? zakazkaId : null);
  const opravy = query.data?.data ?? [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[80vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Na opravu v TopSolide</DialogTitle>
          <DialogDescription className="sr-only">
            Zoznam chýb v exporte, ktoré appka pri importe tejto zákazky
            musela obísť.
          </DialogDescription>
        </DialogHeader>

        {query.isLoading ? (
          <p className="text-sm text-muted-foreground">Načítavam…</p>
        ) : opravy.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            Nič — pri importe tejto zákazky sa nemuselo nič obchádzať.
            Zoznam sa plní automaticky pri importe surového exportu
            z TopSolidu.
          </p>
        ) : (
          <OpravyZoznam opravy={opravy} nadpis="Nálezy z importu" />
        )}
      </DialogContent>
    </Dialog>
  );
}
